import React, { PropTypes } from 'react';
import { AuthorizedComponent } from 'react-router-role-authorization';
import { Button } from 'reactstrap';
import { connect } from 'react-redux';
import Spinner from 'react-spinkit';
import { browserHistory } from "react-router";
import _ from 'lodash';

import { INSTRUCTOR } from "../constants/roles";
import {
    ADD_NOTIFICATION,
    DROPBOXES__REQUESTED, ROLES__SELF__REQUESTED,
    SUBSCRIPTIONS__UPDATE__REQUESTED
} from "../constants/actionTypes";
import NavLink from "../components/NavLink";
import NavBar from "../components/NavBar";
import Card from "../components/bootstrap/Card";
import CardHeader from "../components/bootstrap/CardHeader";
import CardBlock from "../components/bootstrap/CardBlock";
import CardCheckbox from "../components/bootstrap/CardCheckbox";

class SubscriptionPage extends AuthorizedComponent {
    constructor(props) {
        super(props);

        this.userRoles = props.auth.roles;
        this.notAuthorizedPath = '/not-found';

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            subscriptions_checked: {
                late_assignment_email: false,
                not_done_email: false,
                leave_group_email: false,
                empty_group_email: false
            },
            email: "",
        };
    }

    subscribed(subscriptions, email) {
        return _.includes(
            _.first(
                _.filter(
                    subscriptions,
                    (subscription) => {
                        return subscription.type === email;
                    }
                )
            ),
            email
        );
    }

    componentDidMount() {
        const { dispatch } = this.props;

        dispatch({
            type: ROLES__SELF__REQUESTED
        });
    }

    componentDidUpdate(prevProps) {
        const { dispatch, dropboxes, params, roles_self } = this.props,
            dropboxId = parseInt(params.dropboxId)
        ;

        if (prevProps.roles_self !== roles_self) {
            const hasInstructorRole = _.includes(
                    _.flatMap(
                        roles_self,
                        dropbox_role => {
                            if (dropbox_role.dropbox.id === dropboxId) {
                                return dropbox_role.role;
                            }
                        }),
                    INSTRUCTOR,
                ),
                role = hasInstructorRole
                ?
                    _.first(
                        _.filter(
                            roles_self,
                            dropbox_role => {
                                return dropbox_role.role === INSTRUCTOR && dropbox_role.dropbox.id === dropboxId;
                            }
                        )
                    )
                :
                    {},
                email = role.email ?  role.email: "",
                checked = {
                    late_assignment_email: this.subscribed(role.subscriptions, LATE_ASSIGNMENT_EMAIL),
                    not_done_email: this.subscribed(role.subscriptions, NOT_DONE_EMAIL),
                    leave_group_email: this.subscribed(role.subscriptions, LEAVE_GROUP_EMAIL),
                    empty_group_email: this.subscribed(role.subscriptions, EMPTY_GROUP_EMAIL)
                }
            ;

            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({
                email: email,
                subscriptions_checked: checked,
            });

            if (hasInstructorRole) {
                if (_.size(dropboxes) < 1) {
                    dispatch({
                        type: DROPBOXES__REQUESTED
                    });
                }
            } else {
                browserHistory.push('/not-found');
            }
        }
    }

    handleCheckboxChange(e) {
        const { checked, name }  = e.target,
            { subscriptions_checked } = this.state
        ;

        this.setState({
            subscriptions_checked: {
                ...subscriptions_checked,
                [name]: checked
            }
        });
    }

    handleInputChange(e) {
        const { name, value }  = e.target;

        this.setState({
            [name]: value
        });
    }

    handleSubmit(e) {
        e.preventDefault();

        const { email, subscriptions_checked } = this.state,
            { auth, dispatch, dropboxes, params, roles_self } = this.props,
            dropboxId = parseInt(params.dropboxId),
            dropbox = dropboxes[dropboxId],
            dropbox_role = _.first(
                _.filter(
                    roles_self,
                    dropbox_role => {
                        return dropbox_role.role === INSTRUCTOR && dropbox_role.dropbox.id === dropboxId;
                    }
                )
            )
        ;

        if (!email.match(/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/)) {
            dispatch({
                type: ADD_NOTIFICATION,
                payload: {
                    message: "Invalid Email Address.",
                    level: 'error',
                    autoDismiss: 10,
                }
            });
            return false;
        }

        dispatch({
            type: SUBSCRIPTIONS__UPDATE__REQUESTED,
            payload: {
                ...dropbox_role,
                dropbox: dropbox.id,
                user: parseInt(auth.id),
                subscriptions:  _.filter(
                    _.map(subscriptions_checked, (checked, subscription) => {
                        return checked ? { type: subscription } : {};
                    }),
                    subscription => {
                        return subscription.type !== undefined;
                    }
                ),
                email: email
            }
        });

        this.setState({
            submitted: true,
        });
    }

    render() {
        const isLoading = this.props.request.sendingRequest;

        if (isLoading) {
            return (
                <Spinner
                    spinnerName="wandering-cubes"
                    className="spinner"
                    noFadeIn
                />
            );
        }

        const { dropboxes, params } = this.props,
            dropbox = dropboxes[params.dropboxId],
            { email, subscriptions_checked } = this.state
        ;

        return dropbox
            ? (
                <div className="col-md-12">
                    <div className={"action-links"}>
                        <NavBar
                            className="navbar navbar-toggleable-md navbar-light bg-faded fixed-top navbar-sub"
                            display
                        >
                            <NavLink
                                to={`/?expand=${dropbox.id}`}
                                className="btn btn-outline-primary btn-md"
                                side="left"
                                display
                                key="courses"
                            >
                                Exit To Course <i className={"fa fa-chevron-circle-left"}/>
                            </NavLink>
                            <NavLink
                                to="submit"
                                className=""
                                side="right"
                                display
                                key="submit"
                            >
                                <Button
                                    type="button"
                                    onClick={this.handleSubmit}
                                    size="md"
                                    color="success"
                                    title={'Save Email Notifications'}
                                >
                                    Save Email Notifications
                                </Button>
                            </NavLink>
                        </NavBar>
                    </div>
                    <h3>{dropbox.name}</h3>
                    <Card>
                        <CardHeader className="bg-primary">Email Notifications</CardHeader>
                        <CardBlock>
                            <label className="email">Email Address *</label>
                            <div className="col-md-12">
                                <input
                                    name="email"
                                    id="email"
                                    type="text"
                                    placeholder="Email Address"
                                    required="required"
                                    className="form-control"
                                    value={email}
                                    onChange={this.handleInputChange}
                                />
                            </div>
                        </CardBlock>
                        <CardBlock>
                            <CardBlock>
                                <CardCheckbox
                                    side="right"
                                    name="late_assignment_email"
                                    id="late_assignment_email"
                                    onChange={this.handleCheckboxChange}
                                    value={subscriptions_checked.late_assignment_email}
                                    checked={subscriptions_checked.late_assignment_email === true}
                                >
                                    Receive notification of late assignment submissions
                                </CardCheckbox>
                            </CardBlock>
                            <CardBlock>
                                <CardCheckbox
                                    side="right"
                                    name="not_done_email"
                                    id="not_done_email"
                                    onChange={this.handleCheckboxChange}
                                    value={subscriptions_checked.not_done_email}
                                    checked={subscriptions_checked.not_done_email === true}
                                >
                                    Receive notification when a student indicates they are not done with an assignment.
                                </CardCheckbox>
                            </CardBlock>
                            <CardBlock>
                                <CardCheckbox
                                    side="right"
                                    name="leave_group_email"
                                    id="leave_group_email"
                                    onChange={this.handleCheckboxChange}
                                    value={subscriptions_checked.leave_group_email}
                                    checked={subscriptions_checked.leave_group_email === true}
                                >
                                    Receive notification when a student leaves an assignment group.
                                </CardCheckbox>
                            </CardBlock>
                            <CardBlock>
                                <CardCheckbox
                                    side="right"
                                    name="empty_group_email"
                                    id="empty_group_email"
                                    onChange={this.handleCheckboxChange}
                                    value={subscriptions_checked.empty_group_email}
                                    checked={subscriptions_checked.empty_group_email === true}
                                >
                                    Receive notification when an assignment group is empty (all members have left the group)
                                </CardCheckbox>
                            </CardBlock>
                        </CardBlock>
                    </Card>
                </div>
            ) : null
        ;
    }
}

SubscriptionPage.propTypes = {
    dispatch: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    const { auth, dropboxes, request, roles_self } = state;

    return { auth, dropboxes, request, roles_self };
}

export const LATE_ASSIGNMENT_EMAIL = 'late_assignment_email';
export const NOT_DONE_EMAIL = 'not_done_email';
export const LEAVE_GROUP_EMAIL = 'leave_group_email';
export const EMPTY_GROUP_EMAIL = 'empty_group_email';

export default connect(mapStateToProps)(SubscriptionPage);



/** WEBPACK FOOTER **
 ** ./src/containers/SubscriptionPage.js
 **/